import { Navigate } from '@sorare/routing';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_SERIES_ONBOARDING_SELECT_COMPETITION,
  ANY_SPORT_SERIES_ONBOARDING_SELECT_TEAM_SLUG,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const SeriesPage = () => {
  const { sport } = useSportContext();

  if (sport === Sport.FOOTBALL) {
    return (
      <Navigate
        replace
        to={generateSportPath(ANY_SPORT_SERIES_ONBOARDING_SELECT_COMPETITION, {
          sport: Sport.FOOTBALL,
        })}
      />
    );
  }

  if (sport === Sport.NBA) {
    return (
      <Navigate
        replace
        to={generateSportPath(ANY_SPORT_SERIES_ONBOARDING_SELECT_TEAM_SLUG, {
          sport: Sport.NBA,
          params: { slug: 'nba' },
        })}
      />
    );
  }

  return (
    <Navigate
      replace
      to={generateSportPath(ANY_SPORT_SERIES_ONBOARDING_SELECT_TEAM_SLUG, {
        sport: Sport.BASEBALL,
        params: { slug: 'mlb' },
      })}
    />
  );
};
export default SeriesPage;
